module.exports = __webpack_public_path__ + "media/images/hotdog-7116c753634ac39142013559e848cbce.png";